/* globals document, window */
// The client app that the scout file loads into the customers site
require('core-js/fn/promise');
const debug = require('debug')('plugin:client');
const Client = require('./lib/Client');
const localStorage = require('public/js/lib/local-storage.js');

const placeholderHtml = require('html-loader!./static/plugin-placeholder.html');

function initApp({win, doc, RP}) {
	const pluginEl = document.getElementById('rp_plugin');

	// If we do not have a container to render pages into, do not execute
	if (!pluginEl) {
		if (console && console.error) {
			console.error('RevolutionParts: Expected a DOM element with id of "rp_plugin" to be present on-page to render');
		}
		return;
	}

	const renderEl = document.createElement('div');

	RP.serverUrl = PLUGIN_HOST; //'https://dev-pg-bs-plugin-webstore.revolutionparts.vpc';

	/*const placeholderEl = document.createElement('div');
	placeholderEl.style = 'position: absolute; top: 161px; left: 0; right: 0; width: 1000px; margin: 0 auto; min-height: 1000px;';
	placeholderEl.innerHTML = placeholderHtml;*/
	renderEl.innerHTML = placeholderHtml;
	renderEl.id = 'rp_webstore';
	// pluginEl.style.position = 'relative';
	pluginEl.appendChild(renderEl);
	// pluginEl.appendChild(placeholderEl);
	const iframe = doc.createElement('iframe');

	// Find JWT
	const storageJwt = localStorage.getItem('RP_JWT');
	const urlJwt = getJWTParamFromUrl(window.location.search, 'jwt');
	const jwt = urlJwt || storageJwt;
	const jwta = getJWTParamFromUrl(window.location.search, 'jwta');

	new Client({
		window: win,
		renderEl,
		iframe,
		jwta,
		env: {
			pluginHash: RP.hash,
			serverUrl: RP.serverUrl,
			routingMethod: RP.routingMethod,
		},
	});

	const params = [
		`hash=${RP.hash}`,
	];
	if (jwt) {
		params.push(`jwt=${jwt}`);
	}
	if (jwta) {
		params.push(`jwta=${jwta}`);
	}

	const bodyEl = doc.body;
	iframe.style.width = '0';
	iframe.style.height = '0';
	iframe.style.border = 'none';
	iframe.src = `${RP.serverUrl}/?${params.join('&')}`;
	bodyEl.appendChild(iframe);
}

function getJWTParamFromUrl(query, jwtParam) {
	if (typeof query !== 'string') { return; }
	let jwt = null;

	const regex = new RegExp(`.*${jwtParam}=([a-zA-Z0-9._-]+).*`, 'i');
	const jwtParamMatches = query.match(regex);
	if (jwtParamMatches) {
		jwt = jwtParamMatches[1];
	}

	return jwt;
}

(function (doc, win) {
	'use strict';
	const RP = {...win.rp};

	debug('initApp', JSON.stringify({...RP}));
	// Thanks IE10
	// In some cases, the dom is "loaded" before we get to our code and then it doesn't fire our event
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => {
			initApp({win, doc, RP});
		});
	} else {
		setTimeout(() => {
			initApp({win, doc, RP});
		}, 0);
	}
}(document, window));
